import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues, UseFieldArrayAppend } from 'react-hook-form';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import { AppendValue } from '@lib/components/ReactHookForm/types';
import styles from './OptionsAddItemComponent.module.scss';

interface Props {
  append: UseFieldArrayAppend<FieldValues, string>;
  appendCallback: () => void;
  appendValue: AppendValue;
  isAddMoreVisible: boolean;
}

function OptionsAddItemComponent({
  append,
  appendCallback,
  appendValue,
  isAddMoreVisible,
}: Props) {
  const { t } = useTranslation();
  const onClick = () => {
    append(appendValue);
    if (appendCallback) appendCallback();
  };
  return (
    <div className={styles.addItemBtnWrapper}>
      {isAddMoreVisible ? (
        <Button
          buttonSize={ButtonSizes.small}
          buttonText={t('add-range')}
          buttonType={ButtonTypes.secondaryOutlined}
          leftIcon="add"
          onClick={onClick}
        />
      ) : (
        <Tooltip body={t('legend-add-range-disabled-desc')} placement="right">
          <Button
            buttonSize={ButtonSizes.small}
            buttonText={t('add-range')}
            buttonType={ButtonTypes.secondaryOutlined}
            disabled
            leftIcon="add"
            onClick={onClick}
          />
        </Tooltip>
      )}
    </div>
  );
}

export default OptionsAddItemComponent;
